<template>
  <div>
    <el-container>
      <el-header>
        <app-header/>
      </el-header>

      <el-container>
        <app-menu></app-menu>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "app-main-layout",
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/shared/layout/main-layout.vue?4d6b471a